import axios from 'axios'
import { getToken } from './auth'
import { Notification, MessageBox, Message, Loading } from 'element-ui'
import store from '../store'
import errorCode from './errorCode'
import { Toast } from 'vant';
import { removeToken } from '@/utils/auth'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const service = axios.create({
  baseURL: 'https://pc.qdsd398.com/gateway',
  // baseURL: 'http://192.168.100.68:8000',
  withCredentials: true,
  timeout: 5000
})

// 添加请求拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  if (getToken() && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config;
}, error => {
  // 请求错误时做些事
  return Promise.reject(error);
});

// 添加响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const msg = errorCode[code] || res.data.msg || errorCode['default']
  if (code === 401) {
    Toast('登录状态已过期，请重新登录');
    setTimeout(() => {
      removeToken();
      location.href = '/';
    }, 1500)
    return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
  } else if (code === 500) {
    Toast(msg);
    return Promise.reject(res.data)
  } else if (code === 501) {
    setTimeout(() => {
      this.$router.push({
        path: '/'
      })
    }, 1500)
    return Promise.reject(res.data)
    // return Promise.reject(new Error(msg))
  } else if (code !== 200) {
    Notification.error({
      title: msg
    })
    return Promise.reject(res.data)
    // return Promise.reject('error')
  } else {
    return res.data
  }
}, error => {
  return Promise.reject(error.data);  // 返回接口返回的错误信息
})

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js